export const getImageByImageName = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any,
    image: string
) => {
    const foundImage = data.edges.find(
        (elem: {
            node: {
                fluid?: { originalName?: string }
                childImageSharp?: { fluid?: { originalName?: string } }
            }
        }) => {
            const originalName =
                elem.node.fluid?.originalName ||
                elem.node.childImageSharp?.fluid?.originalName

            return originalName === image
        }
    )

    return foundImage?.node?.fluid
        ? foundImage.node
        : foundImage?.node?.childImageSharp ?? null
}
